import api from './api';

const index = () => api.get(`/dashboard`);

export default { index };
